import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, BookOpen, Award, TrendingUp, Sparkles } from "lucide-react";


const CoursesPreviewSection = () => {

    const categories = [
        { name: "Développement", icon: "💻", count: 120 },
        { name: "Design", icon: "🎨", count: 85 },
        { name: "Marketing", icon: "📈", count: 64 },
        { name: "Business", icon: "💼", count: 92 },
        { name: "Data Science", icon: "📊", count: 48 },
        { name: "Photographie", icon: "📷", count: 36 },
    ];

    return (
        <section className="py-20 bg-muted/30 relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute inset-0 geometric-pattern opacity-30" />

            <div className="container mx-auto px-4 relative">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    {/* Left - Content */}
                    <div className="space-y-6">
                        <Badge variant="outline" className="text-primary border-primary/30">
                            <Sparkles className="h-3 w-3 mr-1" />
                            +500 formations
                        </Badge>

                        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">
                            Trouvez la formation qui vous{" "}
                            <span className="text-gradient">correspond</span>
                        </h2>

                        <p className="text-muted-foreground text-lg leading-relaxed">
                            Explorez notre catalogue complet de formations créées par des experts.
                            Filtrez par niveau, catégorie ou prix pour trouver exactement ce dont vous avez besoin.
                        </p>

                        {/* Features */}
                        <div className="grid sm:grid-cols-3 gap-4 pt-4">
                            <div className="flex items-center gap-3">
                                <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
                                    <BookOpen className="h-5 w-5 text-primary" />
                                </div>
                                <div>
                                    <p className="font-semibold text-foreground">500+</p>
                                    <p className="text-sm text-muted-foreground">Cours</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
                                    <Award className="h-5 w-5 text-primary" />
                                </div>
                                <div>
                                    <p className="font-semibold text-foreground">50+</p>
                                    <p className="text-sm text-muted-foreground">Experts</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
                                    <TrendingUp className="h-5 w-5 text-primary" />
                                </div>
                                <div>
                                    <p className="font-semibold text-foreground">20+</p>
                                    <p className="text-sm text-muted-foreground">Catégories</p>
                                </div>
                            </div>
                        </div>

                        {/* CTA */}
                        <div className="pt-4">
                            <Button asChild size="lg" className="w-full bg-african-accent">
                                <Link to="/courses">
                                    Explorer le catalogue
                                    <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                                </Link>
                            </Button>
                        </div>
                    </div>
                    {/* Right - Categories Grid */}
                    <div className="relative">
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                            {categories.map((category, index) => (
                                <Link
                                    key={category.name}
                                    to="/courses"
                                    className={`group p-4 rounded-xl bg-card border border-border/50 hover:border-primary/50 hover:shadow-lg transition-all duration-300 ${index === 0 ? "sm:col-span-2" : ""
                                        }`}
                                >
                                    <span className="text-2xl mb-2 block">{category.icon}</span>
                                    <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors">
                                        {category.name}
                                    </h3>
                                    <p className="text-sm text-muted-foreground">
                                        {category.count} cours
                                    </p>
                                </Link>
                            ))}
                        </div>
                    </div>

                    {/* Floating badge */}
                    <div className="absolute top-2 right-4 bg-african-accent text-primary-foreground px-4 py-2 rounded-full shadow-lg animate-float">
                        <span className="text-sm font-bold">Nouveautés chaque semaine ✨</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CoursesPreviewSection;
